<template>
  <div class="newPage">
    <div class="son">
      <div class="btns">
        <span>选择通道：</span>
        <el-select v-model="checkList2" style="width: 300px;" size="mini" multiple placeholder="请选择">
          <el-option label="CC_A" value="1"></el-option>
          <el-option label="CC_B" value="2"></el-option>
          <el-option label="CC_C" value="3"></el-option>
          <el-option label="CC_D" value="4"></el-option>
          <el-option label="RTD01" value="5"></el-option>
          <el-option label="RTD02" value="6"></el-option>
          <el-option label="RTD02" value="7"></el-option>
          <el-option label="RTD03" value="8"></el-option>
          <el-option label="RTD04" value="9"></el-option>
        </el-select>
        <span style="margin-left: 40px;">通用类型：</span>
        <el-select v-model="checkList2" style="width: 300px;" size="mini" multiple placeholder="请选择">
          <el-option label="CC_A" value="1"></el-option>
          <el-option label="CC_B" value="2"></el-option>
          <el-option label="CC_C" value="3"></el-option>
          <el-option label="CC_D" value="4"></el-option>
          <el-option label="RTD01" value="5"></el-option>
          <el-option label="RTD02" value="6"></el-option>
          <el-option label="RTD02" value="7"></el-option>
          <el-option label="RTD03" value="8"></el-option>
          <el-option label="RTD04" value="9"></el-option>
        </el-select>
        <span style="margin-left: 40px;">传感器：</span>
        <el-select v-model="checkList2" style="width: 300px;" size="mini" multiple placeholder="请选择">
          <el-option label="CC_A" value="1"></el-option>
          <el-option label="CC_B" value="2"></el-option>
          <el-option label="CC_C" value="3"></el-option>
          <el-option label="CC_D" value="4"></el-option>
          <el-option label="RTD01" value="5"></el-option>
          <el-option label="RTD02" value="6"></el-option>
          <el-option label="RTD02" value="7"></el-option>
          <el-option label="RTD03" value="8"></el-option>
          <el-option label="RTD04" value="9"></el-option>
        </el-select>
      </div>
      <div class="scart">
        <div class="n">日期选择</div>
        <el-date-picker size="mini" style="width: 300px;" v-model="temp.c" type="datetimerange" placeholder="选择日期"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <div class="n">选择参数</div>
        <el-radio v-model="radioed" label="1">最大值</el-radio>
        <el-radio v-model="radioed" label="2">平均值</el-radio>
        <div class="n">平均周期</div>
        <el-radio v-model="radioed" label="1">月</el-radio>
        <el-radio v-model="radioed" label="2">日</el-radio>
        <el-radio v-model="radioed" label="3">无</el-radio>

        <el-button type="primary" size="mini" style="margin-left: 10px !important;" @click="submit">数据分析</el-button>
        <el-button type="primary" size="mini" @click="temp={};temp2={};radioed=''">重置</el-button>

      </div>
      <vchart style="height: 32vh;" ref='vchart'></vchart>
      <!-- <div class="btns btned">
        <span>选择通道：</span>
        <el-checkbox-group v-model="checkList3">
          <el-checkbox label="CC_A"></el-checkbox>
          <el-checkbox label="CC_B"></el-checkbox>
          <el-checkbox label="CC_C"></el-checkbox>
          <el-checkbox label="RTD01"></el-checkbox>
          <el-checkbox label="RTD02"></el-checkbox>
          <el-checkbox label="RTD03"></el-checkbox>
          <el-checkbox label="RTD04"></el-checkbox>
          <el-checkbox label="RTD05"></el-checkbox>
          <el-checkbox label="RTD06"></el-checkbox>
          <el-checkbox label="RTD07"></el-checkbox>
          <el-checkbox label="RTD08"></el-checkbox>
          <el-checkbox label="RTD09"></el-checkbox>
          <el-checkbox label="RTD010"></el-checkbox>
          <el-checkbox label="RTD011"></el-checkbox>
          <el-checkbox label="RTD012"></el-checkbox>
          <span class="quxiao" @click="checkList3=[]">取消全部</span>
        </el-checkbox-group>
        <span style="display: flex;align-items: self-start;line-height: 15px;">
          <span style="margin-left: 20px;">平均周期：</span>
          <el-radio v-model="radio2" label="1">每月</el-radio>
          <el-radio v-model="radio2" label="2">每日</el-radio>
          <el-radio v-model="radio2" label="3">无</el-radio>
          <span style="margin-left: 20px;">选择参数：</span>
          <el-radio v-model="radio3" label="1">最大值</el-radio>
          <el-radio v-model="radio3" label="2">平均值</el-radio>
        </span>
      </div> -->
      <div class="xian"></div>
      <vchart style="height: 32vh;" ref='vchart2'></vchart>
    </div>
  </div>
</template>

<script>
  import vchart from '@/components/module/Charts/chart.vue';//echart图
  export default {
    components: {
      vchart
    },
    data () {
      return {
        checkAll: false,
        isIndeterminate: true,
        radio3: '1',
        radio2: '1',
        radioed: '1',
        checkList: [],
        checkList2: [],
        checkList3: [],
        checkList4: [],
        checkList5: [],
        checkList6: [],
        options: {
          "toolbox": {
            "show": true,
            "showTitle": true,
            "top": "5",
            "right": "10",
            "feature": {
              "magicType": {
                "type": [
                  "line",
                  "bar",
                  "stack",
                  "tiled"
                ],
                "title": {
                  "line": "切换为折线图",
                  "bar": "切换为柱状图",
                  "stack": "切换为堆叠",
                  "tiled": "切换为平铺"
                }
              },
              "saveAsImage": {
                "show": true,
                "title": "下载图片"
              }
            }
          },
          "tooltip": {
            "trigger": "axis",
            "confine": true,
            "axisPointer": {
              "animation": false
            }
          },
          "xAxis": {
            type: 'category',
            boundaryGap: false,
            data: [
              "Mar 30",
              "Apr 1",
              "Apr 2",
              "Apr 3",
              "Apr 4",
              "Apr 5",
              "Apr 6",
              "Apr 7",
              "Apr 8",
              "Apr 9",
              "Apr 10",
              "Apr 11",
              "Apr 12",
              "Apr 13",
              "Apr 14",
              "Apr 15",
              "Apr 16",
              "Apr 17"
            ]
          },
          "yAxis": {

          },

          "grid": {
            "left": "2%",
            "right": "2%",
            top: 50,
            "bottom": "35",
            "containLabel": true
          },
          "legend": {
            "type": "scroll",
            "bottom": "5px",
            "tooltip": {
              "show": true
            },

          },
          "series": [{
            "name": "Temp",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "Humidity,%",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "Load,%",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "Mositure in Air",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "Aim Series",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "CC_A-Qmax,mV",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "CC_A-PPC",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "CC_A-PDI,rnW",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },{
            "name": "Aim Count",
            "type": "line",
            "smooth": false,
            "markPoint": {
              "data": []
            },
            "symbol": "emptyCircle",
            "sampling": "average",
            data: [1,2,3,4,5,6,7,1,2,2,3,4,1,6,7,1,2,3]
          },]
        },
        options2: {
          "title": {
            "text": "ChannelDistributionfor-4/14/200613:00",
            top: 10,
            "left": "center",
            "textStyle": {
              "fontSize": 13,
              "fontWeight": "normal",
              "color": "#22a7f2"
            }
          },
          "toolbox": {
            "show": true,
            "showTitle": true,
            "top": "5",
            "right": "50",
            "feature": {
              "magicType": {
                "type": [
                  "line",
                  "bar",
                  "stack",
                  "tiled"
                ],
                "title": {
                  "line": "切换为折线图",
                  "bar": "切换为柱状图",
                  "stack": "切换为堆叠",
                  "tiled": "切换为平铺"
                }
              },
              "saveAsImage": {
                "show": true,
                "title": "下载图片"
              }
            }
          },
          "tooltip": {
            "trigger": "axis",
            "confine": true,
            "axisPointer": {
              "animation": false
            }
          },
          "xAxis": {
            type: 'category',
            axisLabel: {
              rotate: 60, // 旋转标签
              margin: 20 // 标签与轴线之间的距离
            },
            boundaryGap: false,
            data: [
              "CC_A",
              "CC_B",
              "CC_C",
              "RTD01",
              "RTD02",
              "RTD03",
              "RTD04",
              "RTD05",
              "RTD06",
              "RTD07",
              "RTD08",
              "RTD09",
              "RTD10",
              "RTD11",
              "RTD12"
            ]
          },
          "yAxis": {

          },

          "grid": {
            top: 39,
            "left": "2%",
            "right": "2%",
            "bottom": "20",
            "containLabel": true
          },
          "legend": {
            "type": "scroll",
            "bottom": "1px",
            "tooltip": {
              "show": true
            },

          },
          series: [
            {
              "name": "Qmax.mV",
              "type": "bar",
              barGap: 0,
              "smooth": false,
              "markPoint": {
                "data": []
              },
              "symbol": "emptyCircle",
              "sampling": "average",
              "data": ['-','-','-','-','-','-','9','1','1','-','-','-','-','-','-','-','-',]
            },{
              "name": "Puise Count .PPC",
              "type": "bar",
              barGap: 0,
              "smooth": false,
              "markPoint": {
                "data": []
              },
              "symbol": "emptyCircle",
              "sampling": "average",
              "data": ['-','-','-','-','-','-','9','1','1','-','-','-','-','-','-','-','-',]
            },{
              "name": "PD1.mW",
              "type": "bar",
              barGap: 0,
              "smooth": false,
              "markPoint": {
                "data": []
              },
              "symbol": "emptyCircle",
              "sampling": "average",
              "data": ['-','-','-','-','-','-','9','1','1','-','-','-','-','-','-','-','-',]
            },
          ]
        },

        temp: {
          c: new Date()
        },
        temp2: {
          c: new Date()
        },
        aaa: {
          xAxis: {
            type: 'category',
            data: ['Mon','Tue','Wed','Thu','Fri','Sat','Sun']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: [150,230,224,218,135,147,260],
              type: 'bar'
            }
          ]
        }
      }
    },
    mounted () {
      this.$refs.vchart.setData(this.options,true);
      this.$refs.vchart2.setData(this.options2,true);
    },
    computed: {

    },



    methods: {
      submit () {
        this.$message({showClose: true,message: '提交成功',type: 'success'});
      }

    }
  }
</script>

<style lang="scss" scoped>
  .xian {
    border-top: 1px solid #d7d7d7;
    width: 100%;
    margin: 15px 0;

  }

  .quxiao {
    cursor: pointer;
    color: #368ED9;
    font-size: 13px;
  }

  .btned {
    margin-top: 10px;
    margin-bottom: 12px;
  }

  .sel {
    width: 120px;

    input {
      width: 120px;
    }
  }

  .newPage {
    padding: 15px;

    .scart {
      display: flex;
      padding: 10px;
      align-items: center;

      .n:nth-child(1) {
        margin-left: 0;
      }

      .n {
        margin-left: 30px;
        margin-right: 7px;
      }
    }

    .btns {
      display: flex;
      padding-left: 2px;
      padding-top: 10px;
    }

    .son {
      background-color: #fff;
      padding: 10px;
    }
  }
</style>
<style>
  .newPage .el-range-editor--mini .el-range-input {
    box-shadow: none;
  }

  .btned .el-checkbox-group {
    flex: 1;
  }

  .newPage .el-checkbox {
    margin-right: 12px;
  }

  .newPage .el-radio {
    margin-right: 12px;
  }
</style>